import firebase from '../firebase/compat'

const dateInputToTimestamp = (dateInput) => {
    if (!dateInput) return null;
  
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) return null;
  
    return firebase.firestore.Timestamp.fromDate(date);
  };
  
  export default dateInputToTimestamp;
